import { render, staticRenderFns } from "./ed-header-in-session.vue?vue&type=template&id=97902c06&scoped=true&"
import script from "./ed-header-in-session.ts?vue&type=script&lang=ts&"
export * from "./ed-header-in-session.ts?vue&type=script&lang=ts&"
import style0 from "./ed-header-in-session.scss?vue&type=style&index=0&id=97902c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97902c06",
  null
  
)

export default component.exports